// ── SNACK GANG MX — JS ───────────────────────────────────────

// Cart drawer
const overlay = document.querySelector('.sg-overlay');
const drawer = document.querySelector('.sg-drawer');

function openCart() {
  overlay?.classList.add('open');
  drawer?.classList.add('open');
  document.body.style.overflow = 'hidden';
  fetchCart();
}

function closeCart() {
  overlay?.classList.remove('open');
  drawer?.classList.remove('open');
  document.body.style.overflow = '';
}

overlay?.addEventListener('click', closeCart);
document.querySelector('.sg-drawer-close')?.addEventListener('click', closeCart);
document.querySelector('.sg-cart-btn')?.addEventListener('click', openCart);

async function fetchCart() {
  try {
    const r = await fetch('/cart.js');
    const cart = await r.json();
    renderCart(cart);
    updateCount(cart.item_count);
  } catch(e) { console.error(e); }
}

function updateCount(n) {
  document.querySelectorAll('.sg-cart-count').forEach(el => el.textContent = n);
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' MXN';
}

function renderCart(cart) {
  const items = document.querySelector('.sg-drawer-items');
  const subtotal = document.querySelector('.sg-drawer-subtotal span:last-child');
  if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
  if (!items) return;

  if (cart.item_count === 0) {
    items.innerHTML = `<div class="sg-drawer-empty">
      <div style="font-size:48px;margin-bottom:12px">🛒</div>
      <div style="font-family:var(--titan);font-size:20px;color:var(--lime);margin-bottom:6px">Vacío</div>
      <div style="font-size:13px">Agrega algunos snacks</div>
    </div>`;
    return;
  }

  items.innerHTML = cart.items.map(item => `
    <div style="display:flex;gap:12px;padding:14px 0;border-bottom:1px solid var(--bd)">
      <div style="width:64px;height:64px;background:var(--s2);border-radius:8px;overflow:hidden;flex-shrink:0">
        ${item.image
          ? `<img src="${item.image}" style="width:100%;height:100%;object-fit:cover">`
          : `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:24px">🍿</div>`}
      </div>
      <div style="flex:1">
        <div style="font-size:13px;font-weight:600;color:var(--cream);margin-bottom:4px;line-height:1.3">${item.title}</div>
        <div style="font-size:11px;color:var(--muted)">Cantidad: ${item.quantity}</div>
        <div style="font-family:var(--titan);font-size:18px;color:var(--lime);margin-top:4px">${formatMoney(item.final_price)}</div>
      </div>
    </div>`).join('');
}

// Add to cart
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-variant-id]');
  if (!btn) return;
  e.preventDefault();
  const id = btn.dataset.variantId;
  const orig = btn.innerHTML;
  btn.disabled = true;
  btn.innerHTML = '✓';
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: 1 })
    });
    await fetchCart();
    openCart();
  } catch(e) { console.error(e); }
  setTimeout(() => { btn.disabled = false; btn.innerHTML = orig; }, 1500);
});

// Init
fetchCart();
